<template>
    <ul class="poll-voters-list">
        <li v-for="voter in voters" :key="voter.key" class="poll-voter-item">
            <!-- `AvatarField`, não `<img>` cru: ele troca URL quebrada pela imagem
                 padrão e guarda a URL morta num cache compartilhado. Foto de
                 participante de grupo expira, e um `<img>` direto viraria o ícone de
                 imagem quebrada. -->
            <AvatarField v-if="voter.avatar" :foto="voter.avatar" class="poll-voter-avatar" />
            <span v-else-if="voter.initials" class="poll-voter-avatar poll-voter-initials"
                  :style="{ backgroundColor: pastelColorFromString(voter.label) }">
                {{ voter.initials }}
            </span>
            <span v-else class="poll-voter-avatar poll-voter-avatar-blank">
                <i class="ri-user-line"></i>
            </span>
            <span class="poll-voter-name" :class="{ 'poll-voter-name-opaque': voter.isLid }">
                {{ voter.label }}
            </span>
        </li>
        <!-- Voto contado sem votante conhecido. Quase sempre é voto que chegou ao vivo
             (o evento move a contagem sem dizer quem) e some no próximo carregamento da
             conversa; também cobre o voto em opção que a enquete já não tem. O rótulo
             não promete qual dos dois é. -->
        <li v-if="unnamedVotes > 0" class="poll-voter-item">
            <span class="poll-voter-avatar poll-voter-avatar-blank">
                <i class="ri-user-line"></i>
            </span>
            <span class="poll-voter-name poll-voter-name-opaque">
                +{{ unnamedVotes }} {{ unnamedVotes === 1 ? 'votante não identificado' : 'votantes não identificados' }}
            </span>
        </li>
    </ul>
</template>

<script lang="ts">
/**
 * Lista nomeada de votantes de UMA opção de enquete.
 *
 * Componente próprio porque o mesmo bloco aparece em dois popovers: o da contagem
 * de uma opção e o "Ver votos" do rodapé, que empilha todas as opções. Duplicar o
 * markup deixaria os dois divergirem no primeiro ajuste.
 *
 * Sem `<style>`: o popper do floating-vue é teleportado para fora da árvore do
 * componente, então atributo de escopo não chega nele. A aparência mora em
 * `assets/css/poppers-enquete.css`, folha global.
 */
import { defineComponent, PropType } from 'vue';
import { pastelColorFromString } from '@/stores/app/chatUtils';

export type PollVoterLabel = { key: string; label: string; initials: string; avatar?: string; isLid: boolean };

export default defineComponent({
    name: 'PollVotersList',
    props: {
        voters: { type: Array as PropType<PollVoterLabel[]>, required: true },
        /** Votos contados sem votante conhecido nesta opção. */
        unnamedVotes: { type: Number, default: 0 },
    },
    setup() {
        return { pastelColorFromString };
    },
});
</script>
